import { RETRY_OPTIONS, RetryOption } from '@/data/retry-options';

export const getRetryOption = (
    maxRetryCount?: number,
    minRetryDelaySeconds?: number,
) => {
    const option: RetryOption[] = RETRY_OPTIONS.filter(
        (o) =>
            o.value.max_retry_count === maxRetryCount &&
            o.value.min_retry_delay_seconds === minRetryDelaySeconds,
    );

    return option[0];
};
